import { personInfoFrag } from '../../../utils/type/person.common-type';

export const getUserTaskWidgetFrag = `
    id
    userId
    folderId
    folder {
        id
        serviceId
        person {
            ${personInfoFrag}
        }
    }
    title    
    dueDate
    completedAt
    createdAt
    updatedAt
    tags
    files
    shareUsers {
        id
        userTaskId
        userId
        user {
            name
            surname
            titleBeforeName
            titleAfterName
            image
        }
    }
`;
